import { useEffect } from "react";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import VehicleKanbanBoard from "../../components/vehicles/VehicleKanbanBoard";

export default function VehicleBoard() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "Vehicle Board",
      desc: "Track vehicles through the pipeline",
    });
  }, []);

  return <VehicleKanbanBoard max={25} />;
}
